import React from "react";
import { Row, Col } from "reactstrap";

const Headings = ({ headingFocused }) => {
  return (
    <Row className="mb-3 m-auto border-bottom set-scrollbox-width">
      <Col
        xs={22}
        className={`
          offset-2 d-flex align-items-end justify-content-center small text-center fw-bold responsive-fontsize
          ${headingFocused === "category" ? "heading-focused" : "heading"}
        `}
      >
        Namn
      </Col>

      <Col
        xs={8}
        className={`
          offset-1 d-flex align-items-end justify-content-center small text-center fw-bold responsive-fontsize
          ${headingFocused === "amount" ? "heading-focused" : "heading"}
        `}
      >
        Summa
      </Col>
    </Row>
  );
};
export default Headings;
